import './projectH.css';
import hoops from '../../assets/portfolio/hoops.json';
import talenthive from '../../assets/portfolio/talenthive.json';
import latex from '../../assets/portfolio/latex.json';
import crickex from '../../assets/portfolio/crickex.json';
import tetromania from '../../assets/portfolio/tetromania.json';
import pixelcut from '../../assets/portfolio/pixelcut.json';
import topdown from '../../assets/portfolio/topdown.json';
import sre from '../../assets/portfolio/sre-management-suite.json';
import flp from '../../assets/portfolio/nyu-flp-exam-portal.json';
import { Link } from 'react-router-dom';
import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import ProjectCard from '@/components/PortfolioPage/ProjectCard';
import SectionHeading from '../home/SectionHeading';
import '../home/home.css';

const ease = [0.23, 1, 0.32, 1] as const;

const featuredProjects = [
  sre,
  flp,
  hoops,
  talenthive,
  crickex,
  pixelcut,
  tetromania,
  topdown,
  latex,
] as const;

export const ProjectH: React.FC = () => {
  return (
    <section className="home-section projecth" id="Featured">
      <div className="home-section-inner">
        <SectionHeading title="Featured projects" />

        <div className="home-section-body">
          <div className="projecth-grid">
            {featuredProjects.map((project, index) => (
              <motion.div
                key={project.id ?? project.title ?? index}
                className="projecth-card-slot"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.5, ease, delay: (index % 3) * 0.06 }}
              >
                <ProjectCard data={project} />
              </motion.div>
            ))}
          </div>
        </div>

        <div className="projecth-cta">
          <Link to="/portfolio" className="home-action home-action-primary">
            View full portfolio
            <ArrowUpRight />
          </Link>
        </div>
      </div>
    </section>
  );
};
